import { render, staticRenderFns } from "./DetailKasKecil.vue?vue&type=template&id=1bb9d6ff&scoped=true&"
import script from "./DetailKasKecil.vue?vue&type=script&lang=js&"
export * from "./DetailKasKecil.vue?vue&type=script&lang=js&"
import style0 from "./DetailKasKecil.vue?vue&type=style&index=0&id=1bb9d6ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb9d6ff",
  null
  
)

export default component.exports